<template>
  <div>
    <van-overlay :show="loading" class="loading-wrapper">
      <van-loading size="24px" vertical>{{tips}}</van-loading>
    </van-overlay>
    <div class="user">
      <van-image round width="60px" height="60px" fit="cover" :src="$root.$data.user.avatar" />
      <div>{{$root.$data.user.nickname}}</div>
    </div>
    <br />
    <van-form @submit="onSubmit">
      <van-field v-model="formData.plateNumber" name="plateNumber" label="车牌号" placeholder="请输入车牌号" :rules="[{required: true, pattern: plateNumberPattern, message: '车牌不正确'}]">
        <template #input >
          <plate-number-input required v-model="formData.plateNumber"></plate-number-input>
        </template>
      </van-field>
      <van-field v-model="formData.name" name="name" label="姓名" maxlength="15" placeholder="请输入您的姓名" :rules="[{required: true, message: '请输入您的姓名' }]"/>
      <van-field v-model="formData.phone" name="phone" label="手机号" maxlength="11" type="tel" placeholder="请输入您的手机号" :rules="[{pattern: /^1\d{10}/, required: true, message: '请输入您的手机号' }]"/>
      <div class="agree">
        <van-checkbox v-model="agree" name="1" shape="square">我已阅读并同意<a href="http://static.qparking.cn/m/user_agreement.html">《U泊停车用户协议》</a></van-checkbox>
      </div>
      <div style="margin: 16px;">
        <van-button round block type="primary" native-type="submit" :disabled="!agree">提交</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import {  Button, Cell, CellGroup, Checkbox, Field, Form, Image, Loading, Overlay, Tag} from 'vant';
import PlateNumberInputVue from '../components/PlateNumberInput.vue';
import { router } from '../router';
import qs from 'query-string';

export default {
  components: {
    [Button.name] : Button,
    [Tag.name] : Tag,
    [CellGroup.name] : CellGroup,
    [Cell.name] : Cell,
    [Image.name] : Image,
    [Form.name] : Form,
    [Field.name] : Field,
    [Checkbox.name] : Checkbox,
    [Loading.name] : Loading,
    [Overlay.name] : Overlay,
    'plate-number-input': PlateNumberInputVue,
  },
  data() {
    return {
      loading : true,
      parkId: null,
      parkingLotId: 0,
      plateNumberPattern : /.{7,8}/,
      tips: "请稍等",
      interval: null,
      lease: {},
      agree: false,
      formData: {}
    };
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  mounted(){
    const {parkingLotId, parkId} = qs.parse(location.search);
    this.parkingLotId = parkingLotId;
    this.parkId = parkId;
    this.loadStage();
  },
  methods: {
    async onSubmit(values) {
      console.log(values);
      try{
        this.setLoading('提交中....')
        const info = await this.$http.post('/lease/submit', {...values, parkingLotId : this.parkingLotId, parkId: this.parkId});
        this.checkStage(info);
      } catch(e) {
        this.setLoading(false);
      }
      
    },
    async loadStage() {
      if (this.parkingLotId || this.parkId) {
        try{
          const info = await this.$http.get('/lease/Lease_register_info', {parkingLotId : this.parkingLotId, parkId: this.parkId});
          this.lease = info;
          this.checkStage(info);
        } catch(e) {
          this.setLoading(false);
        }
        
      }
      
    },
    setLoading(tips){
      this.loading = !!tips;
      this.tips = tips;
    },
    checkStage(info) {
      if(info) {
        const { name, phone, plateNumber } = info;
        this.formData = { name, phone, plateNumber }
      }
      //未填表单
      if (!info){
        clearInterval(this.interval);
        this.setLoading(false);
      }
      //等待确认
      else if (info.stage==0){
        this.setLoading("正在等待工作人员确认");
        if (!this.interval){
          this.interval = setInterval(this.loadStage, 5000);
        }
      }
      //等待支付
      else if (info.stage == 1){
        router.push('/lease_confirm?parkingLotId='+info.parkingLotId);
      }
    }
  },
  computed: {
  }
};
</script>

<style lang="less" scoped>
  .loading-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .user {
    text-align: center;
    margin: 10px;
  }
  .agree{
    text-align: center;
    margin: 30px 0 30px 16px;
  }
</style>